import { createAction } from '@reduxjs/toolkit';

export const setIsCompletedProfile = createAction('SET_IS_COMPLETED_PROFILE');
export const setIsValidEmail = createAction('SET_IS_VALID_EMAIL');
export const setTeacherId = createAction('SET_TEACHER_ID');
export const setTeacherProfile = createAction('SET_TEACHER_PROFILE');
export const setClassrooms = createAction('SET_CLASSROOMS');
export const setStudents = createAction('SET_STUDENTS');